<template>
    <div id="editor-page-wrapper">
       <div class="toolbar" >
            <hb-tooltip>
            <template v-slot:item>
            <div style="width: 200px;" class="mx-3 px-1">
                <v-select  @change="setStyle('paragraph_style')" v-model="toolbar.paragraph_style" background-color="#f7f7f7" solo flat hide-details dense :items="paragraph_styles">
                </v-select>
            </div>
            </template>
            <template v-slot:header>
                Styles
            </template>
            </hb-tooltip>

            <hb-tooltip>
            <template v-slot:item>
            <v-btn  :color="toolbar.bold ? 'primary': null" icon @click="setStyle('bold')"><v-icon>mdi-format-bold</v-icon></v-btn>
            </template>
            <template v-slot:header>
                Bold
            </template>
            </hb-tooltip>
            
            <hb-tooltip>
            <template v-slot:item>   
            <v-btn  :color="toolbar.italic ? 'primary': null" icon @click="setStyle('italic')"><v-icon>mdi-format-italic</v-icon></v-btn>
            </template>
            <template v-slot:header>
                Italic
            </template>
            </hb-tooltip>
            
            <hb-tooltip>
            <template v-slot:item>    
            <v-btn  :color="toolbar.underline ? 'primary': null" icon @click="setStyle('underline')"><v-icon>mdi-format-underline</v-icon></v-btn>
            </template>
            <template v-slot:header>
                Underline
            </template>
            </hb-tooltip>
           
            <hb-tooltip>
            <template v-slot:item>    
            <v-btn  :color="toolbar.strikethrough ? 'primary': null" icon @click="setStyle('strike')"><v-icon>mdi-format-strikethrough</v-icon></v-btn>
            </template>
            <template v-slot:header>
                Strikethrough
            </template>
            </hb-tooltip>
          
            <hb-tooltip>
            <template v-slot:item>    
            <div style="width: 200px;" class="mx-3">
                <v-select @change="setStyle('font')" v-model="toolbar.font" background-color="#f7f7f7" solo flat hide-details dense :items="fonts"></v-select>
            </div>
            </template>
            <template v-slot:header>
                Font
            </template>
            </hb-tooltip>
          
            <hb-tooltip>
            <template v-slot:item>  
            <div style="width: 125px; display: flex; background-color: #f7f7f7; align-items: center;" class="mx-3">
                <v-btn icon @click="decrement_font_size"><v-icon>mdi-minus</v-icon></v-btn>
                <v-text-field @blur="setStyle('font_size')" v-model="toolbar.font_size" background-color="#f7f7f7" solo flat hide-details dense></v-text-field>
                <v-btn icon @click="increment_font_size"><v-icon>mdi-plus</v-icon></v-btn>
            </div>
            </template>
            <template v-slot:header>
                Font Size
            </template>
            </hb-tooltip>

            <div  style="flex: 0 1 50px">
                <v-select @change="setStyle('align')" v-model="toolbar.align" background-color="#FFFFFF" solo flat hide-details height="38" :items="align_items">
                    <template v-slot:selection="{ item, index }">
                         <hb-tooltip>
                         <template v-slot:item>  
                         <v-icon>mdi-format-align-{{item}}</v-icon>
                        </template>
                        <template v-slot:header>
                            Align & indent
                        </template>
                        </hb-tooltip>
                    </template>
                    <template v-slot:item="{ item, index }">
                        <v-icon>mdi-format-align-{{item}}</v-icon>
                    </template>
                </v-select>
            </div>
            <div>
                <v-menu offset-y elevation="0">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-bind="attrs" v-on="on">
                            <hb-tooltip>
                            <template v-slot:item>  
                            <v-icon>mdi-format-list-bulleted</v-icon>
                            </template>
                            <template v-slot:header>
                                Bulleted list
                            </template>
                            </hb-tooltip>
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-item v-for="(item, index) in list_items" :key="index" @click="setStyle('list', item)">
                            <v-list-item-title><v-icon>mdi-format-list-{{ item }}</v-icon></v-list-item-title>
                        </v-list-item>
                    </v-list>
                    </v-menu>
            </div>


            <div>
                <v-menu offset-y elevation="0">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-bind="attrs" v-on="on">
                        <hb-tooltip>
                         <template v-slot:item>  
                        <v-icon>mdi-format-line-spacing</v-icon>
                       </template>
                        <template v-slot:header>
                            Line & paragraph spacing
                        </template>
                        </hb-tooltip>
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-item v-for="(item, index) in line_heights" :key="index" @click="setStyle('line_height', item)">
                            <v-list-item-title>{{ item }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                    </v-menu>
            </div>

            <hb-tooltip>
            <template v-slot:item>  
            <v-btn icon @click="setStyle('table')"><v-icon>mdi-table</v-icon></v-btn>
            </template>
            <template v-slot:header>
                Insert table
            </template>
            </hb-tooltip>

            <hb-tooltip>
            <template v-slot:item>  
            <v-btn icon @click="setStyle('page_break')"><v-icon>mdi-format-page-break</v-icon></v-btn>
            </template>
            <template v-slot:header>
                Page break
            </template>
            </hb-tooltip>

            <hb-tooltip>
            <template v-slot:item>  
            <v-btn icon @click="show_add_image = true"><v-icon>mdi-image-outline </v-icon></v-btn>
           </template>
            <template v-slot:header>
                Insert image
            </template>
            </hb-tooltip>

            <hb-tooltip>
            <template v-slot:item>  
            <v-btn  @click="preview()" tile elevation="0" class="mr-2"><v-icon class="mr-2">mdi-eye </v-icon> Preview</v-btn>
            </template>
            <template v-slot:header>
                Preview
            </template>
            </hb-tooltip>

            <hb-tooltip>
            <template v-slot:item>  
            <v-btn  :color="toolbar.show_merge_fields ? '#E0F5F5': null" @click="toggleMergeFields" tile elevation="0" class="mr-2"><v-icon class="mr-2">mdi-tag-plus-outline </v-icon> Merge Fields</v-btn>
            </template>
            <template v-slot:header>
                Merge fields
            </template>
            </hb-tooltip>

            <hb-tooltip>
            <template v-slot:item>  
            <v-btn  :color="toolbar.show_header_footer ? '#E0F5F5': null" @click="toggleHeaderFooter"  tile elevation="0">Header &amp; Footer</v-btn>
            </template>
            <template v-slot:header>
                Header & footer
            </template>
            </hb-tooltip>
    
        </div>
        
        <div id="root" :ref="`root_${identifier}`" :style="`flex: 0 1 ${div_height}px;`" >
            <div  class="page" id="page_1">
            
            
                <div class="page-header" @click="focusHeader" :class="{disabled: !toolbar.show_header_footer}" :style="setHeaderHeight"></div>
                    <div class="header-bar"  v-show="toolbar.show_header_footer">
                        <hb-btn color="secondary" @click="clear('header')" class="mr-3">Delete header</hb-btn><hb-btn v-if="isSecure" @click="copy('header')" color="secondary">Copy header to clipboard</hb-btn>
                    </div>

                <div class="page-inner" :class="{disabled: toolbar.show_header_footer}"></div>
                
                <div class="footer-bar" v-show="toolbar.show_header_footer">
                    <hb-btn color="secondary"  @click="clear('footer')" class="mr-3">Delete footer</hb-btn><hb-btn v-if="isSecure" @click="copy('footer')" color="secondary">Copy footer to clipboard</hb-btn>
                </div>
                <div class="page-footer" @click="focusFooter" :class="{disabled: !toolbar.show_header_footer}" :style="setFooterHeight">
                </div>
             

            </div>
        </div>


        <hb-modal    
            title="Insert Image"    
            v-model="show_add_image" 
            size="medium"
            content-padding
        >
            <template v-slot:content>
                <hb-form label="Upload Image" required>
                    <HbFileInput
                        v-model="image.src"
                        v-validate="'required'"
                        data-vv-scope="default"
                        data-vv-name="file_input"
                        data-vv-as="Image File"
                        :error="errors.has('default.file_input')"
                    />
                </hb-form>
                <hb-form label="Alt Text" required>
                     <HbTextField
                        v-model="image.alt"
                        v-validate="'required|max:45|email'"
                        data-vv-scope="default"
                        data-vv-name="alt_text"
                        data-vv-as="Alt Text"
                        :error="errors.has('default.alt_text')"
                    />
                </hb-form>
            </template>
            <template v-slot:right-actions>
                <hb-btn 
                    color="primary" 
                    @click="setImage"
                >
                    Insert Image
                </hb-btn>       
            </template>
        </hb-modal>

        <v-dialog
            v-model="showPdfModal"
            max-width="850px"
            scrollable
            content-class="pdf-dialog"
        >
            <v-card flat tile elevation="0">
            <v-card-text class="pa-0">
                <div class="iframe-container">

                <iframe
                    v-if="pdfPreviewUrl"
                    :src="pdfPreviewUrl"
                    width="100%"
                    height="100%"
                    type="application/pdf"
                    frameborder="0"
                ></iframe>
                <div v-else style="display: flex; justify-content: center; align-items: center; height: 100%">
                    <v-progress-circular

                        indeterminate
                        size="24" 
                        width="2"
                        color="primary"
                    ></v-progress-circular>
                </div>

                </div>
            </v-card-text>
            </v-card>
        </v-dialog>
    </div> 
</template>

<script>

import loadTinyMCE from '@/utils/tinymce-loader';

import { v4 as uuidv4 } from 'uuid';
import { notificationMixin } from "@/mixins/notificationMixin.js";
import { MergeFields } from './MergeFields'; 
import { Tokens } from './Tokens';
import api from '../../../assets/api';

let tinymce = null;

const htmlconverter = (content, filename = "template.html") => {
 const base64Data = btoa(unescape(encodeURIComponent(content)));
 const mime = 'text/html';
 return `mime:${mime};fileName:${filename};base64:${base64Data}`;
}

export default {
    name: "MceEditor",
    data() {
        return {
            div_height: 1000,
            toolbar: {
                bold: false,
                italic: false,
                underline: false, 
                strikethrough: false, 
                paragraph_style: 'Paragraph',
                font: 'Arial',
                font_size: 12,
                align: "left",
                list: 'bulleted',
                show_header_footer: false,
                show_merge_fields: false,

            },
            headerContent: '',
            footerContent: '',
            fonts: ['Arial', "Helvetica", "Tahoma", "Times New Roman"],
            paragraph_styles: [
                {
                    value: 'p',
                    text: 'Paragraph'
                }, 
                {
                    value: 'h1',
                    text: 'Heading 1'
                }, 
                {
                    value: 'h2',
                    text: 'Heading 2'
                }, 
                {
                    value: 'h3',
                    text: 'Heading 3'
                }, 
                {
                    value: 'h4',
                    text: 'Heading 4'
                }, 
                {
                    value: 'h5',
                    text: 'Heading 5'
                },  
                {
                    value: 'h6',
                    text: 'Heading 6'
                },  
                {
                    value: 'pre',
                    text: 'Preformatted'
                }
            ],
            align_items: ['left', 'right', 'center', 'justify'], 
            list_items: ['bulleted', 'numbered'], 
            line_heights: [1, 1.2, 1.4, 1.6, 2.0 ],
            pdfPreviewUrl: null,
            showPdfModal: false,
            show_add_image: false,
            image: {
                src: '', 
                alt_text: ''
            }, 
            value: "", 
            identifier:null, 
            showTags:false,
            apiKey: process.env.VUE_APP_TINYMCE_FREE_API_KEY,

            editorProps: {
                communication: {
                    height: 700,
                    plugins: [
                        'autolink fullpage lists link image anchor preview',
                        'code',
                        'insertdatetime media paste code wordcount noneditable importcss',
                    ],
                    toolbar: 'image code undo redo | formatselect | bold italic backcolor | link | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent insertImage preview mergefields',
                    menubar: false,
                    resize: true,
                    // removed_menuitems: 'table',
                    toolbar_mode: 'floating'
                },
                document: {
                    height: '100%',
                    plugins: [ 'lists', 'advlist',  'link', 'image', 'pagebreak', 'table'],
                    toolbar: 'blocks formatselect bold italic underline strikethrough fontfamily fontsizeinput align numlist bullist lineheight table pagebreak insertImage mergefields headers',
                    menubar: false,
                    resize: false,
                    // removed_menuitems: 'table', 
                    table_default_attributes: {
                        border: '1'
                    }, 
                    toolbar_mode: 'floating'
                }
            }
        }
    },
    components: { 
    },
    props: {
        template: String,
        template_header: String,
        template_footer: String,
        height: {
            type: String,
            default: "100%",
        },
        menubar: {
            type: [Boolean, String],
            default: false,
        },
        show_word_count: {
            type: Boolean,
            default: false
        }, 
        // Possible values: true, false, 'both'
        resize: {
            type: [Boolean, String],
            default: true
        },
        // Type: String 
        removed_menuitems: {
            type: String,
            default: 'inserttable,cell,row,column,tableprops,deletetable'
        },
        document_type: {
            type: String,
            default: 'communication'
        },
        is_closing: {
            type: Boolean,
            default: false
        }
    },
    created(){
        
       
        this.identifier = uuidv4();
 
        
    },
    destroyed(){
       tinyMCE.get('editor_header').destroy()
       tinyMCE.get('editor_footer').destroy()
       tinyMCE.get('editor_primary').destroy()
       window.removeEventListener('resize', this.resizeDiv);
    }, 
    watch: {
        showPdfModal(val) {
            if (!val && this.pdfPreviewUrl) {
            URL.revokeObjectURL(this.pdfPreviewUrl);
            this.pdfPreviewUrl = null;
            }
        },
        is_closing(val) {
            console.log("close")
            this.toolbar.show_merge_fields = false
        }

    },
    computed: {
        setHeaderHeight(){
            console.log("this.headerContent", this.headerContent)
            if(this.toolbar.show_header_footer) {
                return 'flex: 0 1 68px; padding-top: 24px; padding-bottom: 0px;';
            }    
            if(this.headerContent?.length){
                return 'flex: 0 1 0px; padding-top: 24px; padding-bottom: 0px;'
            }
            return 'flex: 0 1 0px; padding-bottom: 0px;'
        
        },
        setFooterHeight(){

            if(this.toolbar.show_header_footer) {
                return 'flex: 0 1 68px; padding-top: 24px; padding-bottom: 24px;';
            }    
            if(this.footerContent?.length){
                return 'flex: 0 1 0px; padding-top: 0px; padding-bottom: 24px;'
            }
            return 'flex: 0 1 0px; padding-bottom: 0px;'
        
        },
        hasHeaderContent(){
            
            return tinyMCE.get('editor_header')?.getContent()
        }, 
        hasFooterContent(){
            return tinyMCE.get('editor_footer')?.getContent()
        },
        isSecure(){
            return window.isSecureContext; 
        }, 
    //     editorConfig() {
    //         return {
                
    //             image_title: true,
    //             block_unsupported_drop: true,
    //             file_picker_types: 'image',
    //             file_picker_callback: this.handleFilePicker,
    //             height: this.editorProps[this.$props.document_type].height,
    //             branding: false,
    //             elementpath: false,
    //             element_format: 'html',
    //             editable_class: 'mceEditable',
    //             custom_elements: 'style, head , meta, html , title',
    //             object_resizing: true,
    //             table_sizing_mode: 'responsive',
    //             invalid_elements: 'script',
    //             content_css: ['default', this.$props.document_type == 'document' ? '/css/editor_styles.css' : '' ], 
    //             resize: false, 
    //             statusbar: false, 
    //             contextmenu:false, 
    //             noneditable_class: 'mceNonEditable',
    //             font_size_formats: '8pt 10pt 12pt 14pt 16pt 18pt 24pt 36pt 48pt', 
    //             line_height_formats: '1 1.2 1.4 1.6 2', 
    //             font_size_input_default_unit: 'pt',
    //             toolbar_persist: true,
    //             menubar: this.editorProps[this.$props.document_type].menubar,
    //             plugins:  this.editorProps[this.$props.document_type].plugins,
    //             toolbar_mode: this.editorProps[this.$props.document_type].toolbar_mode, 
    //             toolbar: this.editorProps[this.$props.document_type].toolbar,
    //             setup: this.editorSetup,

    //         };
    //     }
    },

    async mounted(){
            
        await this.loadEditor();

        window.addEventListener('resize', this.resizeDiv);
        
        if(this.$props.template){
            this.addEditor('primary', this.$props.template);
            this.addEditor('header', this.$props.template_header || '');
            this.addEditor('footer', this.$props.template_footer || '');
    
        } else {

            this.addEditor('primary', "");
            this.addEditor('header', "");
            this.addEditor('footer', "");
        }

        this.resizeDiv();

        
        

    }, 
    methods: {
        focusHeader(){
            tinyMCE.get('editor_header').execCommand('mceFocus');
        },
        focusFooter(){
           tinyMCE.get('editor_footer').execCommand('mceFocus');
        }, 
        isEditorDirty() {
            return tinymce.get('editor_primary')?.isDirty() ||
                tinymce.get('editor_header')?.isDirty() ||
                tinymce.get('editor_footer')?.isDirty();
        },
        async loadEditor() {

            try {
                const { tinymceeditor, tinymcePromise} = await loadTinyMCE();
                await tinymcePromise;
                tinymce = tinymceeditor;
                console.log("tinymce", tinymce)
                
            } catch (error) {
                console.log("error", error)
                // this.showMessageNotification({
                //     type: 'error',
                //     description: error.toString()
                // });
            }
        },
        resizeDiv(){
            this.div_height = window.innerHeight - 65 - 65 - 65 - 49;
        }, 
        decrement_font_size(){
            let height = parseInt(this.toolbar.font_size);
            height--;
            this.toolbar.font_size = height;
            this.setStyle('font_size')
        },
        increment_font_size(){
            let height = parseInt(this.toolbar.font_size);
            height++;
            this.toolbar.font_size = height;
            this.setStyle('font_size')
        },
        async preview() {
             this.showPdfModal = true;
            const content = this.getContent()
            const body = {
                template: htmlconverter(content.template),
            }
            body.template_header = content.template_header ? htmlconverter(content.template_header) : ''
            body.template_header_height = content.template_header_height || ''
            body.template_footer = content.template_footer ? htmlconverter(content.template_footer) : ''
            body.template_footer_height = content.template_footer_height || ''
            const response = await api.downloadFile(
                    this, 
                    api.DOCUMENT + `/preview`, 
                    `temp.pdf`, 
                    body, 
                    false
                );
            if (response) {
                const blob = new Blob([response], { type: 'application/pdf' });
                const url = URL.createObjectURL(blob);
                this.pdfPreviewUrl = url;
               
            }
        }, 
        setStyle(style, value){

            switch(style){
                case 'paragraph_style':
                    tinymce.activeEditor.execCommand('FormatBlock', null, this.toolbar.paragraph_style);
                    break;
                case 'bold':
                    tinymce.activeEditor.execCommand('Bold');
                    break;
                case 'italic':
                    tinymce.activeEditor.execCommand('Italic');
                    break;
                case 'strike':
                     tinymce.activeEditor.execCommand('Strikethrough');
                    break
                case 'underline':
                    tinymce.activeEditor.execCommand('Underline');
                    break
                case 'list':
                    if(value == 'bulleted'){
                        tinymce.activeEditor.execCommand('InsertUnorderedList');
                    } else if(value == 'numbered'){
                        tinymce.activeEditor.execCommand('InsertOrderedList');
                    }
                    break;
                case 'font':
                    tinymce.activeEditor.execCommand('fontName', false, this.toolbar.font);
                    break;
                case 'font_size':
                    tinymce.activeEditor.execCommand('FontSize', false, this.toolbar.font_size + 'px');
                    break;
                case 'align':
                    if(this.toolbar.align == 'left') tinymce.activeEditor.execCommand('JustifyLeft');
                    if(this.toolbar.align == 'right') tinymce.activeEditor.execCommand('JustifyRight');
                    if(this.toolbar.align == 'center') tinymce.activeEditor.execCommand('JustifyCenter');
                    if(this.toolbar.align == 'justify') tinymce.activeEditor.execCommand('JustifyFull');
                    break;
                case 'line_height': 
           
                    tinymce.activeEditor.execCommand('LineHeight', false, value);
                    break;
                case 'page_break': 
                    tinymce.activeEditor.execCommand('mcePageBreak');
                    break;
                case 'table': 
                    tinymce.activeEditor.execCommand('mceInsertTableDialog');
                    break;
            }



        }, 



        async copy(type){
            let content = '';
            switch(type){ 
                case 'header': 
                    try {
                        
                        content = tinyMCE.get('editor_header').getContent();
                        await navigator.clipboard.writeText(content);
                        console.log('Text copied to clipboard successfully!');
                    } catch (err) {
                        console.error('Failed to copy text: ', err);
                        // Fallback for older browsers or if Clipboard API is not available
                        // (e.g., using a temporary textarea and document.execCommand('copy'))
                    }
                    break;
                case 'footer': 
                    content = tinyMCE.get('editor_footer').setContent('');
                    try {
                        await navigator.clipboard.writeText(content);
                        console.log('Text copied to clipboard successfully!');
                    } catch (err) {
                        console.error('Failed to copy text: ', err);
                        // Fallback for older browsers or if Clipboard API is not available
                        // (e.g., using a temporary textarea and document.execCommand('copy'))
                    }
                    break;
                    break;
            }
        }, 
        clear(type){
            switch(type){
                
                case 'header': 
                    tinyMCE.get('editor_header').setContent('');
                    break;
                case 'footer': 
                    tinyMCE.get('editor_footer').setContent('');
                    break;
            }
        }, 
        addEditor(type, content = ''){ 
            
            content = this.replaceTemplateTokens(content)

            const newContainerElement = document.createElement('div');
            newContainerElement.id = `editor_container_${type}`
            newContainerElement.classList.add('mce-editor-container')
            
            const newEditorElement = document.createElement('div');
            newEditorElement.id = `editor_${type}`
            newEditorElement.classList.add('editor')
            newEditorElement.innerHTML = content;
            
            newContainerElement.appendChild(newEditorElement)
            let  referenceElement = null;

            switch(type){
                case 'primary': 
                    referenceElement = document.querySelector('#page_1 > .page-inner');    
                    break;
                case 'header': 
                    referenceElement = document.querySelector('#page_1 > .page-header');    
                    break;
                case 'footer': 
                    referenceElement = document.querySelector('#page_1 > .page-footer');    
                    break;
            }


            referenceElement.appendChild(newContainerElement);
           
            this.$nextTick(() => {
                
                tinymce.EditorManager.execCommand('mceAddEditor', true, { id: `editor_${type}`, options: {

                    inline: true,
                    highlight_on_focus: false,
                    quickbars_selection_toolbar: false,
                    image_title: true,
                    block_unsupported_drop: true,
                    file_picker_types: 'image',
                    branding: false,
                    elementpath: false,
                    element_format: 'html',
                    editable_class: 'mceEditable',
                    custom_elements: 'style, head , meta, html , title',
                    object_resizing: true,
                    table_sizing_mode: 'responsive',
                    invalid_elements: 'script',
                    content_css: [
                        // 'tinymce/skins/ui/oxide/content.min.css',
                        // 'tinymce/skins/ui/oxide/skin.min.css',  
                        // 'tinymce/skins/ui/oxide/skin.shadowdom.min.css',
                        // 'tinymce/skins/content/default/content.min.css',
                        this.$props.document_type == 'document' ? '/css/editor_styles.css' : '',
                        'data:text/css;charset=UTF-8,' + encodeURIComponent(`
                            body:focus { outline: none !important; }
                            *:focus { outline: none !important; box-shadow: none !important; }
                        `)
                    ], 
                    resize: false, 
                    statusbar: false, 
                    contextmenu:false, 
                    noneditable_class: 'mceNonEditable',
                    disabled: type == 'primary' ? false : true, 
                    menubar: this.editorProps[this.$props.document_type].menubar,
                    plugins:  this.editorProps[this.$props.document_type].plugins,
                    toolbar: false,
                    setup: this.editorSetup,
                    apiKey: process.env.VUE_APP_TINYMCE_FREE_API_KEY,
                    license_key: 'gpl'
                } });

            })
            setTimeout(() => {
                switch(type){
                    case 'header': 
                        this.headerContent = tinyMCE.get('editor_header')?.getContent();
                        break
                    case 'footer': 
                        this.footerContent = tinyMCE.get('editor_footer')?.getContent();
                        break;
                }
            }, 0)




                        
            

  
  


        }, 

        getActiveEditor(){
            console.log(tinymce.activeEditor);
        },
         
        onClose() { this.showTags = false; },
        onMouseMove(){
 
        
        }, 
        replaceTemplateTokens(html){
            if(!html) return html;
          
            let value = html.replace(/\{d\.[^}]+\}/g, (match, key) => {
                
                if(match === '{d.Signature}') return `/img/tppx.png`;
                if(match === '{d.Initials}') return `/img/tppx.png`;
                if(match === '{d.ImageBlock1}') return `/img/token.png`;
                if(match === '{d.ImageBlock3}') return `/img/token.png`;
                
                if(this.$props.document_type == 'document'){
                    let token = Tokens.find(mf => mf.token === match); 
                    
                    if(token){
                        return `<span contenteditable="false" data-token-type="${token.type}" data-id="${ uuidv4() }" data-value="${token.token}" data-friendly="${token.label}" class="replaced-text ${token.type}">${token.label}</span>`
                    } 
                } 
                return match;
            });

            value = value.replaceAll('<p style="page-break-before: always;" />', '<!-- pagebreak -->'); 
            return value
        }, 

        getHtml(editor_id){
            let is_signature = false;
            let tmp_content = tinyMCE.get(editor_id).getContent();
            
            let content = JSON.parse(JSON.stringify(tmp_content))
            
            var element = document.createElement('div');
            element.insertAdjacentHTML('beforeend', content);
            element.querySelectorAll('.replaced-text')
                .forEach(function(tag) {
                    const token_type   = tag.getAttribute('data-token-type');
                    let value = "";
                    switch(token_type){
                        case 'initials':
                            is_signature = true
                            value = tag.getAttribute('data-value')                            
                            tag.src = '{d.Initials}'
                            break;
                        case 'signature':
                            is_signature = true
                            value = tag.getAttribute('data-value')                            
                            tag.src = '{d.Signature}'
                            break;
                        case 'imageblock1':
                            is_signature = true
                            value = tag.getAttribute('data-value')                            
                            tag.src = '{d.ImageBlock1}'
                            break;
                        case 'imageblock3':
                            is_signature = true
                            value = tag.getAttribute('data-value')                            
                            tag.src = '{d.ImageBlock3}'
                            break;
                        case 'pricing_table':
                            break;
                        default: 
                            value = tag.getAttribute('data-value');
                            tag.replaceWith(value)
                    }
                }); 


            element.querySelectorAll('table').forEach(function(table) {
                table.setAttribute('width', table.style.width)
            })

            let html = element.innerHTML.replaceAll('<!-- pagebreak -->', '<p style="page-break-before: always;" />')
            
            return html

        }, 

        

        getContent(){
            let template = this.getHtml('editor_primary')
            let template_header = this.getHtml('editor_header')
            let template_footer = this.getHtml('editor_footer')

            const header = document.getElementById('editor_container_header');
            const footer = document.getElementById('editor_container_footer');

            const headerHeight = header.offsetHeight;  // in pixels
            const footerHeight = footer.offsetHeight;

            console.log(" headerHeight",  headerHeight)
            console.log(" footerHeight",  footerHeight)
            const headerHeightMm = headerHeight * 0.264583;  
            const footerHeightMm = footerHeight * 0.264583;
            console.log("headerHeightMm",  headerHeightMm)
            console.log("footerHeightMm",  footerHeightMm)
            return {
                template,
                template_header,
                template_footer,
                template_header_height: template_header ? Math.round(headerHeightMm) + 'mm': null,
                template_footer_height: template_footer ? Math.round(footerHeightMm)  + 'mm' : null
            }
        },  
        updateValue(newValue) {
            this.$emit('input', newValue);
        },
        handleFilePicker(cb, value, meta) {
            const input = document.createElement('input');
            input.setAttribute('type', 'file');
            input.setAttribute('accept', 'image/*');

            input.addEventListener('change', (e) => {
                const file = e.target.files[0];
                const reader = new FileReader();
                reader.addEventListener('load', () => {
                    const id = 'blobid' + new Date().getTime();
                    const blobCache = tinymce.activeEditor.editorUpload.blobCache;
                    const base64 = reader.result.split(',')[1];
                    const blobInfo = blobCache.create(id, file, base64);
                    blobCache.add(blobInfo);
                    cb(blobInfo.blobUri(), { title: file.name });
                });
                reader.readAsDataURL(file);
            });
            input.click();
        },


        showHeaderFooter(should_show){
            this.headerContent = tinyMCE.get('editor_header')?.getContent();
            this.footerContent = tinyMCE.get('editor_footer')?.getContent();
           
            if(should_show){
                tinyMCE.get('editor_header').options.set('disabled', false);
                tinyMCE.get('editor_footer').options.set('disabled', false);
                tinyMCE.get('editor_primary').options.set('disabled', true);
            } else {
                tinyMCE.get('editor_header').options.set('disabled', true);
                tinyMCE.get('editor_footer').options.set('disabled', true);
                tinyMCE.get('editor_primary').options.set('disabled', false);
            }
        }, 

        toggleMergeFields(){
            this.toolbar.show_merge_fields = !this.toolbar.show_merge_fields;
            this.$emit('showMergeFields', this.toolbar.show_merge_fields)
        }, 
        toggleHeaderFooter(){
            this.toolbar.show_header_footer = !this.toolbar.show_header_footer;
            this.showHeaderFooter(this.toolbar.show_header_footer)
        }, 
        editorSetup(editor) {
            
            editor.on('NodeChange', (node) => {
                // console.log("GET", editor.formatter.get())
                this.toolbar.bold = editor.formatter.match('bold')
                this.toolbar.italic = editor.formatter.match('italic')
                this.toolbar.underline = editor.formatter.match('underline')
                this.toolbar.strikethrough = editor.formatter.match('strikethrough')
                this.toolbar.paragraph_style = editor.formatter.matchAll(['h1', 'h2', 'h3','h4', 'h5', 'h6','p'])[0]
                
                var computedStyle = window.getComputedStyle(editor.selection.getNode());
                // Get the font family
                
                this.toolbar.font = computedStyle.getPropertyValue("font-family")
                this.toolbar.line_height = computedStyle.lineHeight
                this.toolbar.font_size = parseInt(computedStyle.fontSize)
                this.toolbar.align = computedStyle.textAlign == 'start' ? 'left' : computedStyle.textAlign
                
            })


            return (api) => {}
        },
        setImage() {
            
            if (this.image.src.length === 0) {
                alert("Please select an image.");
                return;
            }

            const file = this.image.src[0];
            const reader = new FileReader();
            
            reader.onload = function(event) {

                const imgElement = document.createElement("img"); // Create new <img> element
                imgElement.src = event.target.result; // Set the Base64 data URL
                imgElement.classList.add('inserted-image')
                imgElement.classList.add('mceResizable')
                imgElement.setAttribute('data-mce-resize', 1);
                console.log("imgElement.outerHTML", imgElement.outerHTML)
                tinymce.activeEditor.insertContent(imgElement.outerHTML, {select: true});
            };

            reader.readAsDataURL(file); // Convert to Base64
            
            this.image = {
                src: [],
                alt: ''
            }
            this.show_add_image = false; 
            return;
            tinymce.activeEditor.insertContent(`<img  data-mce-resize="1"  class="mceResizable" src="${this.image.src}" />`, {select: true});
            
        }, 
        insertToken(token){
            
            let id = uuidv4();
            if(token.type == 'signature'){ 
                tinymce.activeEditor.insertContent(`<img style="display: inline-block; width: 180px; height: 100px;"  data-mce-resize="1" data-token-type="${token.type}" data-id="${ id }" data-value="${token.token}" data-friendly="${token.label}" data-placeholder="/img/tppx.png" class="mceResizable mceNonEditable replaced-text ${token.type}" src="/img/tppx.png" />`, {select: true});
                
                setTimeout(() => {
                    const editor = tinymce.activeEditor;
                    let img = editor.getBody().querySelector(`#${id}`);
                    img.getNode().setAttribute("data-mce-resize","1");         
                    editor.selection.controlSelection.showResizeRect(img);
                        editor.selection.select();
                
                }, 100);


                // tinymce.activeEditor.execCommand('mceInsertContent', false, `<span contenteditable="false" data-token-type="${token.type}" data-id="${ uuidv4() }" data-value="${token.token}" data-friendly="${token.label}" class="replaced-text ${token.type}"><img src="${token.token}" style="width: 180px; height: 100px;" />Sign Here</span>`);
            } else if(token.type == 'initials'){
                tinymce.activeEditor.insertContent(`<img style="display: inline-block; width: 90px; height: 100px;"  data-mce-resize="1" data-token-type="${token.type}" data-id="${ id }" data-value="${token.token}" data-friendly="${token.label}" data-placeholder="/img/tppx.png" class="mceResizable mceNonEditable replaced-text ${token.type}" src="/img/tppx.png" />`, {select: true});
                // tinymce.activeEditor.execCommand('mceInsertContent', false, `<span contenteditable="false" data-token-type="${token.type}" data-id="${ uuidv4() }" data-value="${token.token}" data-friendly="${token.label}" class="resizable replaced-text ${token.type}"><img src="${token.token}" style="width: 90px; height: 100px;" /></span>`);
            } else if(token.type == 'imageblock1'){
                tinymce.activeEditor.insertContent(`<img style="display: inline-block; width: 250px; height: 175px;" data-mce-resize="1" data-token-type="${token.type}" data-id="${id}" data-value="${token.token}" data-friendly="${token.label}" data-placeholder="/img/token.png" class="mceResizable mceNonEditable replaced-text ${token.type}" src="/img/token.png" />`, {select: true});
            } else if(token.type == 'imageblock3'){
                tinymce.activeEditor.insertContent(`<img style="display: inline-block; width: 225px; height: 300px;" data-mce-resize="1" data-token-type="${token.type}" data-id="${id}" data-value="${token.token}" data-friendly="${token.label}" data-placeholder="/img/token.png" class="mceResizable mceNonEditable replaced-text ${token.type}" src="/img/token.png"/>`, {select: true});
                
            } else if(token.type == 'pricing_table'){
                tinymce.activeEditor.execCommand('mceInsertContent', false, `<div contenteditable="false" data-token-type="${token.type}" data-id="${ uuidv4() }" data-value="${token.token}" data-friendly="${token.label}" class="replaced-text ${token.type}">
                    <table width="75%" style="font-family: helvetica, sans-serif; page-break-inside: avoid; width: 100%; border-collapse: collapse;" cellpadding="0" cellspacing="0"> 
                    
                        <col width="40*"/>
                        <col width="20*"/>
                        <col width="20*"/>
                        <col width="20*"/>
                            
                        <tr>
                            <th valign="middle" style="background: #e3f0f1; border-bottom: 1px solid #ccc; color: #000000; font-size: 10pt;" align="left"><p style="margin: 0.06in">&nbsp;&nbsp; Item Name &nbsp;&nbsp;</p></th>
                            <th valign="middle" style="background: #e3f0f1; border-bottom: 1px solid #ccc; color: #000000; font-size: 10pt;" align="right"><p style="margin: 0.06in">&nbsp;&nbsp; Price &nbsp;&nbsp;</p></th>
                            <th valign="middle" style="background: #e3f0f1; border-bottom: 1px solid #ccc; color: #000000; font-size: 10pt;" align="right"><p style="margin: 0.06in">&nbsp;&nbsp; Qty &nbsp;&nbsp;</p></th>
                            <th valign="middle" style="background: #e3f0f1; border-bottom: 1px solid #ccc; color: #000000; font-size: 10pt;" align="right"><p style="margin: 0.06in">&nbsp;&nbsp; Line Total &nbsp;&nbsp;</p></th>
                        </tr>
                        <tr>
                            <td style="color: #000000; font-size: 10pt;" align="left"><p style="margin: 0.06in">&nbsp;&nbsp; {d.PricingTable.lines[i].name} &nbsp;&nbsp;</p></td>
                            <td style="color: #000000; font-size: 10pt;" align="right"><p style="margin: 0.06in">&nbsp;&nbsp; {d.PricingTable.lines[i].price} &nbsp;&nbsp;</p></td>
                            <td style="color: #000000; font-size: 10pt;" align="right"><p style="margin: 0.06in">&nbsp;&nbsp; {d.PricingTable.lines[i].qty} &nbsp;&nbsp;</p></td>
                            <td style="color: #000000; font-size: 10pt;" align="right"><p style="margin: 0.06in">&nbsp;&nbsp; {d.PricingTable.lines[i].total} &nbsp;&nbsp;</p></td>
                        </tr>
                        <tr>
                            <td style="color: #000000; font-size: 10pt;" align="left"><p style="margin: 0.06in">&nbsp;&nbsp; {d.PricingTable.lines[i+1].name} &nbsp;&nbsp;</p></td>
                            <td style="color: #000000; font-size: 10pt;" align="right"><p style="margin: 0.06in">&nbsp;&nbsp; {d.PricingTable.lines[i+1].price} &nbsp;&nbsp;</p></td>
                            <td style="color: #000000; font-size: 10pt;" align="right"><p style="margin: 0.06in">&nbsp;&nbsp; {d.PricingTable.lines[i+1].qty} &nbsp;&nbsp;</p></td>
                            <td style="color: #000000; font-size: 10pt;" align="right"><p style="margin: 0.06in">&nbsp;&nbsp; {d.PricingTable.lines[i+1].total} &nbsp;&nbsp;</p></td>
                        </tr>
                        
                        <tr>
                            <td style="border-top: 1px solid #ccc; color: #000000; font-size: 10pt;" colspan="3" align="right"><p style="margin: 0.06in">&nbsp;&nbsp; Subtotal &nbsp;&nbsp;</p></td>
                            <td style="border-top: 1px solid #ccc; color: #000000; font-size: 10pt;" align="right"><p style="margin: 0.06in">&nbsp;&nbsp; {d.PricingTable.subtotal} &nbsp;&nbsp;</p></td>
                        </tr>
                        <tr>
                            <td style="color: #000000; font-size: 10pt;" align="right" colspan="3"><p style="margin: 0.06in">&nbsp;&nbsp; Tax &nbsp;&nbsp;</p></td>
                            <td style="color: #000000; font-size: 10pt;" align="right"><p style="margin: 0.06in;">&nbsp;&nbsp; {d.PricingTable.tax} &nbsp;&nbsp;</p></td>
                        </tr>
                        <tr>
                            <td style="color: #000000; font-size: 10pt;" align="right" colspan="3"><p style="margin: 0.06in">&nbsp;&nbsp; <strong>Total</strong> &nbsp;&nbsp;</p></td>
                            <td style="color: #000000; font-size: 10pt;" align="right"><p style="margin: 0.06in">&nbsp;&nbsp; <strong>{d.PricingTable.total}</strong> &nbsp;&nbsp;</p></td>
                        </tr>
                        <tr>
                            <td style="color: #000000; font-size: 10pt;" align="right" colspan="3"><p style="margin: 0.06in">&nbsp;&nbsp;&nbsp;&nbsp;</p></td>
                            <td style="color: #000000; font-size: 10pt;" align="right"><p style="margin: 0.06in">&nbsp;&nbsp;&nbsp;&nbsp;</p></td>
                        </tr>
                    
                    </table>
                </div>`);
            } else {
                tinymce.activeEditor.execCommand('mceInsertContent', false, `<span contenteditable="false" data-token-type="${token.type}" data-id="${ uuidv4() }" data-value="${token.token}" data-friendly="${token.label}" class="replaced-text ${token.type}">${token.label}</span>`);
            }
        }

    
    },



};
</script>

<style scoped>

.tox.tox-tinymce-inline .tox-editor-header{
    background-color: white;
    border: none;
    border-radius:none;

}
    #root .mce-editor-container{
        position: relative;
        /* padding: 20px 0;     */
    }

    #root .tox-tinymce-inline { 
        z-index: 999999 !important;
        }
    #root .editor{
        flex: 1; 
    }

    #root .page-header #editor_header,
    #root .page-header #editor_footer{
        /* margin-top: 24px;
        padding-bottom: 24px; */
        min-height: 40px;
    }

    #root .page-header.disabled #editor_header,
    #root .page-header.disabled #editor_footer{
        min-height: 0px;
    }


    #root .mce-editor-container .editor-add-btn:hover > div{
         display: block;
    }

    #root .editor:focus{
        outline: none;
        
    }


    #root .page-inner.disabled, 
    #root .page-footer.disabled, 
    #root .page-header.disabled{
        opacity: .5;
    }


    #root .page-content {
        padding: 50px;
        height: 100%;
    }

    #root .page-inner{
        flex: 1 0; 
        margin-left: 50px; 
        margin-right: 50px; 
        /* margin-top: 20px;
        margin-bottom: 20px; */
        display: flex; 
        flex-direction: column;
    }

    #root{
        background-color: #F9FAFB; overflow: auto; height: 100%;  
    }

    #root .page{
        display: flex; 
        flex-direction: column; 
        justify-content: flex-start; 
        align-items: stretch; 
        max-width: 800px;
        min-height: 1038px;
        
        width: 100%;
        background-color: #FFFFFF; 
        margin: 40px auto !important; 
        border-radius: 4px; 
        border: 2px solid #DFE3E8;
    }
    #root .page-footer, 
   #root .page-header{
        /* flex: 0 1 68px;  */
        padding-left: 50px;
        padding-right: 50px;
    }

    #root .footer-bar{
        flex: 0 1 68px; background-color: #F9FAFB; padding: 16px; text-align: right; border-bottom: 1px solid #E3E3E3; 
    }

    #root .header-bar{
       flex: 0 1 68px; background-color: #F9FAFB; padding: 16px; text-align: right; border-top: 1px solid #E3E3E3;
    }
    #root #editor_container_header{
        padding-bottom: 0;
    }

    #root #editor_container_footer{
        padding-top: 0;
    }

    #editor-page-wrapper .toolbar{
        display: flex; align-items: center; width: 100%; border-bottom: 1px solid #e2e2e2; min-height: 44px; padding: 5px; background-color: white; flex-wrap: wrap
    }
    #editor-page-wrapper{
        display: flex; flex-direction: column; align-items: stretch; border-right: 1px solid rgba(0, 0, 0, 0.12);  
    }
    .pdf-dialog {
    overflow: hidden !important;
    max-height: 90vh;
    }

    .iframe-container {
    height: 80vh;
    overflow: hidden;
    padding-bottom: -5px; /* Gives space at the bottom */
    }

    iframe {
    display: block;
    width: 100%;
    height: 100%;
    border: none;
    overflow: hidden;
    }
</style>
